import React, { FC } from 'react';

import { CopyOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import styles from './ConnectBizon.module.scss';
import { copyToClipboard } from '../../../../helpers/utils/safeClipboard';
import { showErrorMessage, showSuccessMessage } from '../../../../helpers/utils/ui';
import MainLayout from '../../../../shared/common/components/layouts/MainLayout';
import PageHead from '../../../../shared/common/components/page-header/PageHeader';
import { useActions } from '../../../../shared/common/hooks/useActions';
import { useTypedSelector } from '../../../../shared/common/hooks/useTypedSelector';

const ConnectBizon: FC = () => {

    const { id } = useTypedSelector((state) => state.currentUser);
    const { selectedSchool } = useTypedSelector((state) => state.currentSchool);
    const { setAppReportOpen, setDrawerLink } = useActions();

    const script = `
    <!— =====analitika.school=====START========== —>
    <script>
    var school_webvisor = {
        user_id: ${id},
        school_id: ${selectedSchool?.id || 0},
        params: {
            launch_delay: 0,
            interval: 10000
        }
    };
    
    (function(conf) {
        let GETParams, script;
    
        GETParams = new URLSearchParams({
            user_id: conf.user_id,
            school_id: conf.school_id,
        });
    
        script = document.createElement('script');
        script.setAttribute('src','https://api.analitika.school/script_bizon?' + GETParams.toString());
        script.setAttribute("async","true");
        document.documentElement.children[0].appendChild(script);
    })(window.school_webvisor || {});
    </script>
    <!— ===== analitika.school=====END========== —>

    `;

    const copyScript = async () => {
        const success = await copyToClipboard(script);
        if (success) {
            showSuccessMessage('Скрипт скопирован.');
        } else {
            showErrorMessage('Произошла ошибка при копировании.');
        }
    };

    const instructionBtn = (
        <span
            style={{
                marginLeft: 10,
                marginRight: 10,
                marginTop: 3,
                cursor: 'pointer',
            }}
            onClick={() => {
                try {
                    setDrawerLink('https://doc.scananalytics.ru/nastrojka/podklyuchenie-bizon365/?_highlight=bi');
                    setAppReportOpen(true);
                } catch (err) {
                    console.error(err);
                }
            }}
        >
            <QuestionCircleOutlined
                style={{ color: '#ccc', fontSize: 14, marginTop: '8px', marginLeft: '-10px' }}
            />
        </span>
    );

    return (
        <MainLayout pageTitle="Подключение Bizon365">
            <div className="page-wrapper">
                <PageHead title="Скрипт для Bizon365" extraContent={instructionBtn} />

                <div className="page-content">
                    <div>
                        <p>
                            Скопируйте и вставьте данный скрипт в настройках комнаты Bizon365, раздел Разное-{'>'}HTML-{'>'}Постоянный HTML/JS-код.
                        </p>

                        <Button
                            type="primary"
                            icon={<CopyOutlined />}
                            onClick={() => copyScript()}
                            className={styles.copyButton}
                        >
                            Скопировать в буфер
                        </Button>

                        <pre className={styles.scriptPane}>
                            {script}
                        </pre>
                    </div>
                </div>
            </div>
        </MainLayout>
    );
};

export default ConnectBizon;
